import React from 'react';

const scrollMap = { 'For Brands': 'brands', 'For Creators': 'creators' };

const columns = [
  { title: 'Company',  links: ['About', 'Press'] },
  { title: 'Services', links: ['For Brands', 'For Creators', 'Analytics'] },
  { title: 'Legal',    links: ['Privacy Policy', 'Terms', 'Cookies'] },
];

export default function Footer() {
  return (
    <footer style={{ borderTop: '1px solid #1e1e1e', padding: '60px 56px 40px', background: '#0a0a0a' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
        <div className="footer-top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '56px', flexWrap: 'wrap', gap: '40px' }}>

          {/* Brand */}
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: '18px', fontWeight: 800, letterSpacing: '0.08em', color: 'var(--white)', display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', textTransform: 'uppercase', cursor: 'pointer' }}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <div style={{ width: '32px', height: '32px', background: 'var(--accent)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', fontWeight: 900, color: '#0a0a0a' }}>N</div>
              Niles Ascend
            </div>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '13px', color: 'rgba(255,255,255,0.35)', maxWidth: '240px', lineHeight: 1.7 }}>
              Where brands ascend through the power of authentic influence.
            </p>
            <div style={{ marginTop: '20px', fontFamily: 'var(--font-body)', fontSize: '13px', color: 'rgba(255,255,255,0.5)', fontWeight: 500 }}>
              info@nileascendteam.com
            </div>
          </div>

          {/* Nav columns */}
          <div className="footer-links" style={{ display: 'flex', gap: '64px', flexWrap: 'wrap' }}>
            {columns.map((col) => (
              <div key={col.title}>
                <div style={{ fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '20px' }}>
                  {col.title}
                </div>
                {col.links.map((l) => {
                  const id = scrollMap[l];
                  const isSoon = !id && col.title !== 'Services';
                  return (
                    <div key={l} onClick={() => id && document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })}
                      style={{ fontFamily: 'var(--font-body)', fontSize: '13px', fontWeight: 500, color: isSoon ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.5)', marginBottom: '12px', cursor: id ? 'pointer' : 'default', transition: 'color 0.2s' }}>
                      {l}{isSoon ? ' (Soon)' : ''}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '24px', borderTop: '1px solid #1e1e1e', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', color: 'rgba(255,255,255,0.25)', fontWeight: 500 }}>
            © 2026 Niles Ascend. All rights reserved.
          </div>
          <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', color: 'rgba(255,255,255,0.25)', fontWeight: 500 }}>
            Columbus, OH
          </div>
        </div>
      </div>
    </footer>
  );
}
